import React, { useState, useEffect, useCallback } from "/vendor/react";
import PropTypes from "prop-types";
import { GoogleLogin } from "react-google-login";
import { gapi } from "gapi-script";
import axios from "axios";
import { useLocation } from "/vendor/react-router-dom";
import jws from "jws-jwk/src/shims";
import { createStyledComponent } from "/lib/component/util";
import {
  DialogActions,
  TextField,
  Button,
  IconButton,
  InputAdornment,
} from "/vendor/@material-ui/core";
import { VisibilityIcon, VisibilityOffIcon } from "../../icon";
import { makeStyles } from "/vendor/@material-ui/styles";

const helperTextStyles = makeStyles(theme => ({
  root: {
    margin: 4,
    color: "black",
  },
  error: {
    "&.MuiFormHelperText-root.Mui-error": {
      color: theme.palette.common.white,
    },
  },
}));

const StyledDialoagActions = createStyledComponent({
  name: "SignInForm.Actions",
  component: DialogActions,
  styles: theme => ({
    marginTop: theme.spacing(5),
    textAlign: "right",
  }),
});

const SignInForm = ({
  disabled,
  error,
  onSubmit,
  passwordForm,
  currentUser,
  resetPassword,
}) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [user, setUser] = useState(null);
  const [jwk, setJwk] = useState(null);
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const helperTextClasses = helperTextStyles();

  const clientId =
    "906291544846-21hp4kko88ju2v6a6vl5t05d0eohgd92.apps.googleusercontent.com";

  const jwkEndpoint = "https://www.googleapis.com/oauth2/v2/certs";

  const location = useLocation();

  const handleSubmit = useCallback(
    ev => {
      onSubmit({
        username: username.trim(),
        password,
      });
      ev.preventDefault();
    },
    [username, password, onSubmit],
  );

  useEffect(() => {
    // Fetch the JWK object from the endpoint
    axios
      .get(jwkEndpoint)
      .then(response => {
        setJwk(response.data);
      })
      .catch(error => {
        console.error("Failed to fetch JWK object:", error);
      });
  }, []);

  useEffect(() => {
    const initClient = () => {
      gapi.client.init({
        clientId: clientId,
        scope: "",
      });
    };
    gapi.load("client:auth2", initClient);
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");
    if (!token) {
      return;
    }
    if (jwk !== null) {
      const verified = jws.verify(token, jwk); // Use the fetched JWK object
      if (verified) {
        const givenName = queryParams.get("givenName");
        const familyName = queryParams.get("familyName");
        const email = queryParams.get("email");
        if (email !== "") {
          localStorage.setItem("googleUser", email);
        }
        setUser({
          givenName,
          familyName,
        });
      } else {
        alert("Account not valid, sign in with a betmakers account");
      }
    }
  }, [location.search, jwk]);

  function signIn(name, pass) {
    onSubmit({
      username: name,
      password: pass,
    });
  }

  function createUser(name, pass) {
    axios
      .post(
        "https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/api/core/v2/users",
        {
          spec: {
            username: name,
            password: pass,
            disabled: false,
          },
          api_version: "core/v2",
          type: "User",
          metadata: {
            name,
          },
        },
        {
          headers: {
            Authorization: "Key 4caca05b-d536-48b8-9fa0-fbb6f3726f47",
            "Content-Type": "application/json",
          },
        },
      )
      .then(() => {
        signIn(name, pass);
      })
      .catch(err => {
        alert("failed to create user", err);
      });
  }

  useEffect(() => {
    if (user !== null) {
      const name = `${user.givenName}${user.familyName}`
        .toLocaleLowerCase()
        .replace(/\s+/g, "");
      const pass = btoa(name);
      axios
        .get(
          "https://api.onewatch.hardware-inno.gcpprodau.tbm.sh/api/core/v2/users",
          {
            headers: {
              Authorization: "Key 4caca05b-d536-48b8-9fa0-fbb6f3726f47",
            },
          },
        )
        .then(res => {
          const currentUser = res.data.find(a => a.spec.username === name);
          if (currentUser) {
            // login
            signIn(name, pass);
          } else {
            // create user
            createUser(name, pass);
          }
        })
        .catch(err => {
          alert("failed to fetch users", err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const onSuccess = res => {
    setUser(res.profileObj);
    localStorage.setItem("googleUser", res.profileObj.email);
  };

  const onFailure = () => {
    setUser(null);
  };

  if (jwk === null) {
    return null;
  }

  return (
    <>
      {passwordForm ? (
        <div>
          <TextField
            type={isShowPassword ? "text" : "password"}
            name="password"
            label="Password"
            inputProps={{
              "aria-label": "Password",
              autoCorrect: "false",
              autocapitalize: "none",
              spellCheck: false,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    color="primary"
                    aria-label="toggle password visibility"
                    onClick={() => setIsShowPassword(!isShowPassword)}
                  >
                    {isShowPassword ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            autoComplete="password"
            disabled={disabled}
            fullWidth
            margin="normal"
            onChange={ev => setNewPassword(ev.target.value)}
            value={newPassword}
            error={!!error}
            // helperText={error}
          />
          <TextField
            type={isShowPassword ? "text" : "password"}
            name="confirm password"
            label="Confirm Password"
            inputProps={{
              "aria-label": "Confirm Password",
              autoCorrect: "false",
              autocapitalize: "none",
              spellCheck: false,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    color="primary"
                    aria-label="toggle password visibility"
                    onClick={() => setIsShowPassword(!isShowPassword)}
                  >
                    {isShowPassword ? (
                      <VisibilityOffIcon />
                    ) : (
                      <VisibilityIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            autoComplete="password"
            disabled={disabled}
            fullWidth
            margin="normal"
            onChange={ev => setConfirmNewPassword(ev.target.value)}
            value={confirmNewPassword}
            error={!!error}
            helperText={error}
          />
          <StyledDialoagActions>
            <Button
              color="primary"
              variant="contained"
              disabled={
                disabled ||
                (newPassword !== confirmNewPassword || newPassword === "") ||
                newPassword.length < 8
              }
              onClick={() => {
                resetPassword({ currentUser, newPassword });
              }}
            >
              Set Password
            </Button>
          </StyledDialoagActions>
        </div>
      ) : (
        <>
          <GoogleLogin
            clientId={clientId}
            buttonText="Sign in with BetMakers"
            onSuccess={onSuccess}
            onFailure={onFailure}
            cookiePolicy={"single_host_origin"}
            // isSignedIn={true}
          />
          <form onSubmit={handleSubmit}>
            <TextField
              name="username"
              label="Username"
              inputProps={{
                "aria-label": "Username",
                autoCorrect: "false",
                autocapitalize: "none",
                spellCheck: false,
              }}
              autoComplete="username"
              disabled={disabled}
              fullWidth
              margin="normal"
              onChange={ev => setUsername(ev.target.value)}
              value={username}
              error={!!error}
            />
            <TextField
              type={isShowPassword ? "text" : "password"}
              name="password"
              label="Password"
              inputProps={{
                "aria-label": "Password",
                autoCorrect: "false",
                autocapitalize: "none",
                spellCheck: false,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      color="primary"
                      aria-label="toggle password visibility"
                      onClick={() => setIsShowPassword(!isShowPassword)}
                    >
                      {isShowPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              autoComplete="current-password"
              fullWidth
              onChange={ev => setPassword(ev.target.value)}
              value={password}
              disabled={disabled}
              error={!!error}
              helperText={error}
              FormHelperTextProps={{
                classes: helperTextClasses,
              }}
            />
            <StyledDialoagActions>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={disabled}
              >
                Sign in
              </Button>
            </StyledDialoagActions>
          </form>
        </>
      )}
    </>
  );
};

SignInForm.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  passwordForm: PropTypes.bool,
  currentUser: PropTypes.string,
  resetPassword: PropTypes.func,
};

SignInForm.defaultProps = {
  disabled: false,
  error: null,
};

export default SignInForm;
